export default __webpack_public_path__ + "static/media/circle_placid.ad65fe18.jpg";